module.exports = __webpack_public_path__ + "img/18a001-01.3e1a3f56.jpg";